import { useSelector } from 'react-redux';
import type { VoidFunctionComponent } from 'react';

import * as IssuesV2Store from '../../../../redux/issuesV2';
import Button from '../../../generic/Button/Button';
import { useIssueDetailsModals } from '../IssueDetailsModalsContext';
import type { AffectedProject, ProjectScope } from '../../../../../shared/issuesV2';

/**
 * IssueDetailsActionButtonViewPath displays the View Path button,
 * which allows the user to view the path that brought this dependency
 * into this project. Works exactly the same as the one on the projects table.
 */
const IssueDetailsActionButtonViewPath: VoidFunctionComponent = () => {
  const scope = useSelector(IssuesV2Store.selectors.getScope) as ProjectScope;
  const { isAnyModalOpen, viewPathModal } = useIssueDetailsModals();

  return (
    <Button
      type="secondary"
      size="medium"
      onClick={() => {
        //  This informs the viewProps modal to use the scope to determine the root to look for here.
        viewPathModal.onOpen({ id: scope.id } as AffectedProject);
      }}
      isDisabled={isAnyModalOpen}
    >
      View Path
    </Button>
  );
};

export default IssueDetailsActionButtonViewPath;
